import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
class ShareComponent extends BridgeComponent {
    static component = "share";
    connect() {
        super.connect();
    }

    share() {
        const url = window.location.href;
        this.send("connect", { url }, () => {
            window.triggerToast(url, 'info');
        });
    }
}
export default ShareComponent;
